import React from 'react';
import CompanyHeader from '../CompanyHeader';
import CompanyContent from '../CompanyContent';

const Company = () => {
    return (
        <>
            <CompanyHeader />
            <CompanyContent />
        </>
    );
};

export default Company;
